import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
import {Root} from './ReferralAdminList.css';
import {
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Button,
    InputBase,
    Dialog,
    Drawer,
    TableFooter,
    TablePagination,
    TextField,
    MenuItem
} from '@material-ui/core';
import {BASE_URL} from '../../store/config';
import instance from '../../request/http';
import {roleStr, roleName, roleInfo} from '../../common/common';
import {getToday, timeFormat, toMoney, getMonthName} from '../../common/utils';
import AlertDialog from '../Layout/components/AlertDialog'
import Toast from '../Layout/components/Toast';
import {Search} from '@material-ui/icons';
import ReferralInfoView from '../ReferralList/components/ReferralInfoView';

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
const ADMIN = "admin";
let UNLISTEN;

class ReferralAdminList extends PureComponent {
    constructor(props) {
        super(props);
        const curtMonth = getMonthName(new Date().getMonth()),
            curtYear = new Date().getFullYear(),
            initDate = this.initDate();
        this.state = {
            refereeData: [],
            statisticData: [
                {
                    title: curtMonth,
                    title2: "Total Amount",
                    value: 0
                }, {
                    title: curtYear,
                    title2: "Total Amount",
                    value: 0
                },
            ],
            statusArr: [
                {
                    title: "All",
                    value: "all"
                }, {
                    title: "Completed",
                    value: "completed"
                }, {
                    title: "Signed",
                    value: "signed"
                }, {
                    title: "Referral",
                    value: "referral"
                }, {
                    title: "Passed",
                    value: "passed"
                },
            ],
            status: "all",
            fromDate: initDate.from,
            toDate: initDate.to,
            openReferralView: false,
            dialogTitle: "",
            dialogState: "",
            dialogData: null,
            passNote: "",
            openPassView: false,

            page_index: 1,
            page_size: 5,
            total_items: 0,

            showAlert: false,
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.setUrlParam = this.setUrlParam.bind(this);
        this.doGetReferee = this.doGetReferee.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.handlePassCancel = this.handlePassCancel.bind(this);
        this.handlePassInfo = this.handlePassInfo.bind(this);
    }

    render() {
        const {
            refereeData,
            statisticData,
            fromDate,
            toDate,
            statusArr,
            status,
            openReferralView,
            dialogTitle,
            dialogState,
            openPassView,
            passNote,

            page_index,
            page_size,
            total_items,

            showAlert,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const editBtnView = (row) => {
            if (row.status !== "pass" && row.status !== "completed") {
                return <Button size="small" variant="outlined" color="primary"
                               onClick={e => this.handleEdit(e, row)}>Edit</Button>
            }
        }
        return (
            <Root>
                <div className="statisticBar h h-bt">
                    <div className="h">
                        {statisticData.map((row, index) => (
                            <div className="textWapper f" key={index}>
                                <div className="title">{row.title}</div>
                                <div className="title">{row.title2}</div>
                                <div className="time">${toMoney(row.value)}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="tableTool h h-bt">
                    <div className="h">
                        <div>From</div>
                        <TextField
                            id="date"
                            type="date"
                            variant="outlined"
                            className="textDateField"
                            value={fromDate}
                            onChange={e => this.handleDateChange(e, 'fromDate')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                style: {
                                    height: 1,
                                },
                            }}
                        />
                        <div>To</div>
                        <TextField
                            id="date"
                            type="date"
                            variant="outlined"
                            className="textDateField"
                            value={toDate}
                            onChange={e => this.handleDateChange(e, 'toDate')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                style: {
                                    height: 1,
                                },
                            }}
                        />
                        <div className="h">
                            <Button size="small" variant="outlined" onClick={e => this.handleDate(e, 1)}>Daily</Button>
                            <Button size="small" variant="outlined"
                                    onClick={e => this.handleDate(e, 2)}>Monthly</Button>
                            <Button size="small" variant="outlined" onClick={e => this.handleDate(e, 3)}>Yearly</Button>
                        </div>
                        <div className="status-block h">
                            <div>Status</div>
                            <TextField
                                select
                                className="textField"
                                value={status}
                                onChange={e => this.handleSelect(e, "status")}
                                margin="dense"
                                variant="outlined"
                            >
                                {statusArr.map(option => (
                                    <MenuItem key={option.title} value={option.value}>
                                        {this.formatStatus(option)}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>
                    </div>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Date</TableCell>
                                <TableCell>Referor</TableCell>
                                <TableCell>Referee</TableCell>
                                <TableCell>Case Number</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Legal Fee</TableCell>
                                <TableCell>Referral Fee</TableCell>
                                <TableCell>Operations</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {refereeData.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell>{row.referral_date}</TableCell>
                                    <TableCell>{row.referer.first_name + " " + row.referer.last_name}</TableCell>
                                    <TableCell>{row.referee.first_name + " " + row.referee.last_name}</TableCell>
                                    <TableCell>{row.case_number? row.case_number : "--"}</TableCell>
                                    <TableCell>
                                        <div
                                            style={{
                                                backgroundColor: this.bgColor(row.status),
                                                borderRadius: "50px",
                                                color: "#fff",
                                                fontWeight: "bold"
                                            }} className="c"
                                        >{row.status}</div>
                                    </TableCell>
                                    <TableCell>${toMoney(row.legal_fee)}</TableCell>
                                    <TableCell>${toMoney(row.rate * row.legal_fee)}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button size="small" variant="outlined" color="primary"
                                                    onClick={e => this.handleView(e, row)}>View</Button>
                                            {editBtnView(row)}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {refereeData.length === 0 && (
                                <TableRow style={{height: 300}}>
                                    <TableCell colSpan={13}/>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    colSpan={13}
                                    count={total_items}
                                    page={refereeData.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: {'arialabel': 'Rows per page'},
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Dialog maxWidth={false} open={openReferralView}>
                    <ReferralInfoView
                        // handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        // data={crtMatterObj}
                        // caseId={case_id}
                        // caseNumber={caseNumber}
                        state={dialogState}
                    ></ReferralInfoView>
                </Dialog>
                <Dialog maxWidth={false} open={openPassView}>
                    <div style={{width: "800px", padding: "30px 50px"}}>
                        <div className="c" style={{color: "#A04730", fontWeight: "bold", fontSize: "16px"}}>Sorry your
                            case has been passed
                        </div>
                        <div style={{width: "100%", marginTop: "30px"}}>
                            <div><b>Referee Pass Note:</b></div>
                            <div>{passNote}</div>
                        </div>
                        <div style={{
                            width: '100%',
                            height: '1px',
                            margin: "20px 0",
                            backgroundColor: '#A1A1A1',
                            opacity: '0.13'
                        }}></div>
                        <div className="h h-r">
                            <Button style={{marginRight: "20px"}} variant="contained"
                                    onClick={this.handlePassCancel}>CANCEL</Button>
                            <Button variant="contained" color="primary" onClick={this.handlePassInfo}>details</Button>
                        </div>
                    </div>
                </Dialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this invoice?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }

    componentDidMount() {
        this.doGetReferee();
        this.mountStatisticData();
        UNLISTEN = this.props.history.listen(route => {
            this.doGetReferee();
        });
    }

    componentWillUnmount() {
        UNLISTEN && UNLISTEN();
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    initDate() {
        const date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth(),
            from = new Date(y, m, 1),
            to = new Date(y, m + 1, 0);

        return {
            from: this.formatDay(from),
            to: this.formatDay(to)
        }
    }

    doGetReferee() {
        const page_index = this.getQueryVariable("page_index");
        const page_size = this.getQueryVariable("page_size");
        this.setState({
            page_index,
            page_size
        }, () => {
            this.getRefereeData();
        })
    }

    mountStatisticData() {
        const {
            statisticData,
        } = this.state;

        //current month
        let year = new Date().getFullYear(), month = new Date().getMonth();
        const firstDayM = new Date(year, month, 1),
            lastDayM = new Date(year, month + 1, 0);
        this.getStatistic(firstDayM, lastDayM, res => {
            statisticData[0].value = res.data.data.amount;
            this.setState({
                statisticData
            });
        });

        //current year
        const firstDayY = new Date(year, 0, 1),
            lastDayY = new Date(year, 11, 31);
        this.getStatistic(firstDayY, lastDayY, res => {
            statisticData[1].value = res.data.data.amount;
            this.setState({
                statisticData
            });
        });
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleView(e, row) {
        if (row.status === "pass") {
            this.openPassDialog(row);
        } else {
            this.openInfo(row);
        }
    }

    handleEdit(e, row) {
        this.props.history.push("/main/editreferral?id=" + row.id + "&state=" + EDIT);
    }

    handleSelect(e, name) {
        const value = e.target.value;
        this.setState({
            [name]: value,
        }, () => {
            this.getRefereeData();
        })
    }

    handleCancel() {
        this.closeDialog();
    }

    handleDateChange(e, name) {
        const value = e.target.value;
        const {fromDate, toDate} = this.state;
        let fromDateStamp = new Date(fromDate).getTime();
        let toDataStamp = new Date(toDate).getTime();
        let valueDateStamp = new Date(value).getTime();
        if (name === "fromDate") {
            if (valueDateStamp > toDataStamp) {
                this.setState({
                    [name]: value,
                    toDate: value
                }, () => {
                    this.getRefereeData();
                })
            } else {
                this.setState({
                    [name]: value,
                }, () => {
                    this.getRefereeData();
                })
            }
        } else if (name === "toDate") {
            if (valueDateStamp < fromDateStamp) {
                this.showToast("The selected time cannot be earlier than the from time", "warning");
                return;
            } else {
                this.setState({
                    [name]: value,
                }, () => {
                    this.getRefereeData();
                })
            }
        }
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    handleAlertYes() {
        this.delInvoice(this.crtInvoiceId);
        this.setState(() => ({
            showAlert: false
        }));
    }

    handleAlertNo() {
        this.setState(() => ({
            showAlert: false
        }));
    }

    handleChangePage(e, newPage) {
        const {page_size} = this.state;
        const page_index = newPage + 1;
        console.log("newPage", newPage)
        console.log(page_index, page_size)
        this.setUrlParam(page_index, page_size);
    }

    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setUrlParam(1, page_size);
    }

    handleDate(e, type) {
        let fromDate = "";
        let toDate = "";
        if (type === 1) {//Daily
            fromDate = getToday();
            toDate = getToday();
        } else if (type === 2) {//Monthly
            fromDate = this.getMonthDay(true);
            toDate = this.getMonthDay(false);
            console.log(fromDate, toDate)
        } else if (type === 3) {//Yearly
            fromDate = this.getYearly(true);
            toDate = this.getYearly(false);
            console.log(fromDate, toDate)
        } else {
            return;
        }
        this.setState({
            fromDate,
            toDate
        }, () => {
            this.getRefereeData();
        })
    }

    handlePassCancel() {
        this.closeDialog();
    }

    handlePassInfo() {
        this.openInfo(this.state.dialogData);
    }

    openInfo(data) {
        this.props.history.push("/main/editreferral?id=" + data.id + "&state=" + VIEW);
    }

    getMonthDay(isFirst = true) {
        let date = new Date(), y = date.getFullYear(), m = date.getMonth();
        const firstDay = new Date(y, m, 1);
        const lastDay = new Date(y, m + 1, 0);
        return isFirst ? this.formatDay(firstDay) : this.formatDay(lastDay);
    }

    getYearly(isFirst = true) {
        let date = new Date(), y = date.getFullYear();
        const firstDay = new Date(y, 0, 1);
        const lastDay = new Date(y, 11, 31);
        return isFirst ? this.formatDay(firstDay) : this.formatDay(lastDay);
    }

    formatDay(date) {
        var d = date;
        var day = ("0" + d.getDate()).slice(-2);
        var month = ("0" + (d.getMonth() + 1)).slice(-2);
        return d.getFullYear() + "-" + (month) + "-" + (day);
    }

    openDialog(title, state) {
        this.setState(() => ({
            openReferralView: true,
            dialogTitle: title,
            dialogState: state
        }));
    }

    openPassDialog(data) {
        this.setState(() => ({
            openPassView: true,
            passNote: data.description,
            dialogData: data,
        }));
    }

    closeDialog() {
        this.setState(() => ({
            openReferralView: false,
            openPassView: false,
        }));
    }

    getRefereeData() {
        const {
            status,
            page_index,
            page_size,
            fromDate,
            toDate
        } = this.state;
        const referee_id = roleInfo.identity.id;
        let params = {
            referee_id,
            start_referral_date: fromDate,
            end_referral_date: toDate,
            page_index,
            page_size
        }
        if (status !== "all") params["status"] = status;
        this.getReferee(params);
    }

    setUrlParam(page_index, page_size) {
        const tabIndex = this.getQueryVariable("tab_index");
        this.props.history.push("/main/referral?tab_index=" + tabIndex + "&page_index=" + page_index + "&page_size=" + page_size);
    }

    getQueryVariable(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return parseInt(decodeURIComponent(r[2]));
        }
        return 0;
    }

    bgColor(name) {
        if (name === "referral") {
            return "#18C6FF";
        } else if (name === "signed") {
            return "#fcba03";
        } else if (name === "completed") {
            return "#43D79E";
        } else if (name === "pass") {
            return "#C1C0C2";
        }
    }

    formatStatus(status) {
        let styleName = "stateBall";
        if (status.value === "all") {
            styleName += " colorCombo";
        } else if (status.value === "completed") {
            styleName += " colorGreen";
        } else if (status.value === "referral") {
            styleName += " colorBlue";
        } else if (status.value === "signed") {
            styleName += " colorYellow";
        } else {
            styleName += " colorGrey";
        }
        return (
            <div>
                <div className={styleName}></div>
                {status.title} </div>
        );
    }

    //---------------request---------------
    getReferee(params) {
        instance.get(BASE_URL + 'admin/referrals', {params}).then((res) => {
            const refereeData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(refereeData)
            this.setState(() => ({
                refereeData,
                page_size,
                total_items
            }));
        }).catch((err) => {
            console.log(err)
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }

    getStatistic(startDate, endDate, callback) {
        const params = {
            start_referral_date: startDate,
            end_referral_date: endDate,
        };
        instance.get(BASE_URL + 'statistic/referrals', {params}).then((res) => {
            console.log(res);
            callback(res);
        }).catch((err) => {
            console.log(err)
        })
    }
}

export default withRouter(ReferralAdminList);